import { render, staticRenderFns } from "./page-analysis.vue?vue&type=template&id=0c4d3c0c&scoped=true"
import script from "./page-analysis.vue?vue&type=script&lang=js"
export * from "./page-analysis.vue?vue&type=script&lang=js"
import style0 from "./page-analysis.vue?vue&type=style&index=0&id=0c4d3c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d3c0c",
  null
  
)

export default component.exports